function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".a{stroke-width:1px;stroke:#000;}.b{fill:none;stroke-width:10;stroke:#000;}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m62.1 601.6-53.5-36.6 22.1 54.3-30.2-16.5 32.6 40.7-27.8-12.5s16.1 29.1 30.2 35.8c8.7 4.1 19.5 2.1 29 0.4 14.3-2.5 26.3-17 40.7-15.3 10.6 1.3 16.4 14.9 26.6 18.1 7.4 2.4 15.9 2.6 23.3 0.4 5.9-1.7 9.3-8.9 15.3-10.1 7.6-1.4 15.1 6.7 22.5 4.8 7.2-1.8 9.5-14.2 16.9-14.5 9.7-0.3 14 14.6 23.3 17.3 5.3 1.5 11.4 0.8 16.5-1.2 9.3-3.6 13.7-16.2 23.3-18.5 4.4-1 8.9 1.6 13.3 2.8 6.3 1.7 12.1 7.3 18.5 6 8.6-1.7 11.9-14 20.1-16.9 4.7-1.6 10-0.6 14.9 0.4 15.3 3 28.3 17.5 43.9 16.5 7.4-0.5 12.4-9.2 19.7-10.5 8-1.4 16.3 1.3 24.2 3.2 10.6 2.5 20.2 12.5 31 10.9 7.3-1.1 10.4-13.8 17.7-13.3 7.9 0.6 9.8 13.2 16.9 16.9 7.5 3.9 17.5 8.5 25 4.4 8.3-4.5 6.6-17.8 10.9-26.2 5-9.8 14.6-17.5 17.3-28.2 1.8-7.2-0.1-14.8-1.2-22.1-2-13.2-10.1-38.6-10.1-38.6l-0.4 40.7s-11.9-13.5-15.3-21.7c-3.4-8.4 0.7-19.4-4.4-27-14.3-20.9-65.2-38.6-65.2-38.6z",
  className: "a"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m64.3 150.4c-13-6.4 42.6-5.1 46.7-19.4 4.7-16.1-30-22.7-25.4-27.8 56.9-62 203.9-177.8 388.9-8.9l2.1 31.9 15.3 19.4 15.3 53.4-0.7 130.4-11.8 31.9 13.2 15.3v196.3",
  className: "b"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m323.9 15.3s-13.3 25.5-28.7 32.8c-23.5 4.8-52.1 1.4-79.7 2.4-10.2 0.4-24.8-1.3-34.2 4-10.2 5.8-17.3 26.6-17.3 26.6s14.4-18.9 25-22.9c12.3-4.7 39.4 0.4 39.4 0.4l-27.4 30.6s-14.1 21.9-18.5 22.9c-7 1.6-30.1-2.4-38.6-2.8-9.5 4.6-20.1 12.9-20.1 12.9l26.6-6.4 16.9 5.6s-15.9 14.8-20.9 24.2c-4.7 8.6-8.1 28.2-8.1 28.2s8.7-19.9 14.5-29c5.8-9 20.1-25 20.1-25s10.1 0.5 14.5-1.6c8-3.9 18.5-19.3 18.5-19.3s1.4 20.1 5.6 29c5.9 12.6 26.6 32.2 26.6 32.2l4.8 21.7 0.8-29.8 18.5 0.8-33-12.1c-12-11.3-16.1-30-15.3-53.1 0 0 19.4-6.9 25-16.5 1.9-3.3 4-9.3 4-9.3s43.4-0.4 59.6-4.8c12.5-8.9 41.9-36.9 41.9-36.9z",
  className: "a"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m155.1 201.8c-13.8 0.1-26.9 1.4-26.9 1.4-29.2-1.1-20.1 18.4-9.8 18.6l24 0.5 1.5 65.7c-0.5 8.5 12.5 20.6 18.2 6.4l2-26.5c19.1 4.8 27 18.7 35.3 32.4 9.4 5.4 19.3 11.7 17.7-10.8l-20.6-28.4c16-16.4 16.8-49.9-18.4-57.6-6.1-1.3-14.6-1.7-22.9-1.7zm16.3 21.2c5.6-0.1 11.9 5.1 15.8 17.7-9.4 1-18.8 2.7-28.2 0 0.4-10.7 5.9-17.6 12.3-17.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m260.4 205.6c9.2 2.1 12.6 14 16.4 28l-0.5 61.8c-6.4 2.8-12.8 2.8-19.1 0l0.5-66.7c-0.3-3.2-6.2-7-6.1-14.5 0-2.8 2.6-10 8.8-8.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m323.4 203.6c-30.3-0.3-20.4 22.5-19.6 22.6 7 1 20.7 0.6 20.6 1-2 22.4 1.9 53.7 2.4 67.7 0.4 10.7 18.3 13.1 19.1 4.4 0.5-5.7 0-31.9 0-31.9l19.6-3.4c28.9-6.7 26.7-59.6 4.4-59.8zm22.5 21c32.1-0.3 27.9 23.8-3.1 25.1-2.9-7.5-1.8-16.2-0.1-25 1.1-0.1 2.2-0.1 3.2-0.1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m63.8 636.5c1-1.7 20.1-46.1 20.1-46.1l4.2 24.3 12.1-9.4 2.1 31.6z",
  className: "a"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m238.3 636.1c1-3.1 11.1-41.3 11.1-41.3l9 44.4z",
  className: "a"
});

var SvgTomb = function SvgTomb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 547.6 672.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
    d: "m56.1 635-9.7-314 31.8-4.8-28.2-17.3 0.4-99.8s7.7-21.5 8.9-22.7c1.1-1.1-1.4-25.6-1.4-25.6l35.6-3.1-12.5-39.6c171.5-171.4 325.1-80.1 390-8.5l1.1 28.2 17.1 17.1 15.9 52.7-1.4 130.9-12 32.4 13.7 13.4-1.7 235.4-29.9 29.9z",
    style: {
      fill: "#e5e5e5",
      strokeLinejoin: "bevel",
      strokeWidth: 6,
      stroke: "#000"
    }
  }), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTomb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tomb.019d3555.svg";
export { ForwardRef as ReactComponent };